module.exports = __webpack_public_path__ + "img/pjysct.210b4303.png";